export const ENDPOINTS = {
    login: { url : "/3z4mkell5g5aset/authenticate", secure: false },
    authorize: { url : "/3z4mkell5g5aset/authorize", secure: true },
    account_master: { url : "/master/account-master", secure: true },
    member_master: { url : "/master/member-master", secure: true },
    option_values: { url : "/master/option-values/values", secure: true },
    fetch_loan_types: { url : "/master/loan-type", secure: true },
    fetch_loan_type_by_id: { url : "/master/loan-type/{id}", secure: true },
    create_loan_types: { url : "/master/loan-type", secure: true },
    fetch_master_notice: { url : "/master/notice", secure: true },
    create_update_master_notice: { url : "/master/notice", secure: true },
    fetch_term_deposits: { url : "/master/term-deposit", secure: true },
    create_term_deposits: { url : "/master/term-deposit", secure: true },
    create_term_deposit_pre_mature_interest : { url : "/master/term-deposit/pre-mature-interest", secure: true },
    create_term_depositInterest: { url : "/master/term-deposit/deposit-type-interest", secure: true },
    fetch_term_deposit_interest: { url: "/master/term-deposit/deposit-type-interest/parent/{parentId}", secure: true },
    fetch_term_deposit_interest_premature: { url: "/master/term-deposit/pre-mature-interest/parent/{parentId}", secure: true },
    fetch_term_deposits_accounts: { url : "/loan-deposit/term-deposit", secure: true },
    search: { url: "/search", secure: true }
  };

export const ACTIONS = {
  login: "auth/login",
  authorize: "auth/authorize",
  account_master: "master/account-master",
  account_save: "master/account-save",
  member_master: "master/member-master",
  member_master_by_id: "master/member-master-by-id",
  member_save: "master/member-save",
  option_values: 'master/option-values',
  loan_types: "master/loanTypes/fetchLoanTypes",
  create_loan_types: "master/loanTypes/createLoanType",
  fetch_master_notice: "master/notice",
  creeate_update_master_notice: "master/notice",
  fetch_term_deposits: "master/termDeposits/fetchTermDeposits",
  create_term_deposits: "master/termDeposits/createLoanType",
  fetch_term_deposits_interest: "master/termDeposits/fetchTermDepositsInterest",
  fetch_term_deposits_interest_pre_mature: "master/termDeposits/pre-mature-interest/parent",
  create_term_deposit_pre_mature_interest: "/master/term-deposit/pre-mature-interest",
  fetch_term_deposit_accounts: "loandeposits/depositAccounts/fetchTermDeposits",
  search: "search"

};